<template>
    <div class="q-pa-md q-gutter-sm">
        <q-dialog :value="value" persistent maximized transition-show="slide-up" @input="$emit('input', $event)" @hide="$emit('input', false)">
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Movimientos Bancarios</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-table :data="items.detalles || []" :columns="columns" row-key="name" >
                        <template v-slot:top-left>
                            <div>{{items.descripcion}} | {{items.banco}} | {{items.numCuenta}} | {{items.moneda}} | {{ formatoFecha(items.fechaInicial) }} | {{ formatoFecha(items.fechafinal) }}</div>
                        </template>
                        <template v-slot:top-right>
                            <q-input borderless dense debounce="300" v-model="filter" placeholder="Filtrar">
                                <template v-slot:append>
                                    <q-icon name="search" />
                                </template>
                            </q-input>
                        </template>
                        <template v-slot:body="props">
                            <q-tr :props="props" :class="props.row.conciliado != 0 ? 'bg-green-1 text-green-9' : ''">
                                <!-- Columna acciones manual -->
                                <q-td key="acciones" :props="props">
                                    <q-btn icon="mdi-clipboard-list-outline" round dense flat color="primary" @click="verAsientos(props.row)">
                                        <q-tooltip>Asignar Asientos</q-tooltip>
                                    </q-btn>
                                    <q-btn v-if="props.row.conciliado != 0" icon="mdi-format-list-numbered" round dense flat color="primary" @click="verAsientos(props.row)">
                                        <q-tooltip>Ver Asientos</q-tooltip>
                                    </q-btn>
                                </q-td>

                                <!-- Resto de columnas -->
                                <q-td v-for="col in props.cols.filter(c => c.name !== 'acciones')" :key="col.name" :props="props">
                                {{ col.value }}
                                </q-td>
                            </q-tr>
                        </template>
                        
                        <!-- <template v-slot:body-cell-acciones="props">
                            <q-td :props="props">
                            <q-btn icon="mdi-clipboard-list-outline" round dense flat color="primary" @click="verAsientos(props.row)">
                                <q-tooltip>Ver Asientos</q-tooltip>
                            </q-btn>
                            </q-td>
                        </template> -->
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>
        <q-dialog v-model="dialogAsientos">
             <q-card style="width: 900px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Asientos Contables de Bancos</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="row q-col-gutter-sm">
                        <div class="col-12">
                            <q-input outlined :value="formatoFecha(objMovimiento.fecha)" label="Fecha" dense readonly />
                        </div>
                        <div class="col-4">
                            <q-input outlined v-model="objMovimiento.rfc" label="RFC" dense readonly />
                        </div>
                        <div class="col-8">
                            <q-input outlined v-model="objMovimiento.nombre" label="Nombre" dense readonly />
                        </div>
                        <div class="col-6">
                            <q-input outlined :value="formatoMiles(objMovimiento.deposito)" label="Depósito" dense readonly input-class="text-right"/>
                        </div>
                        <div class="col-6">
                            <q-input outlined :value="formatoMiles(objMovimiento.retiro)" label="Retiro" dense readonly input-class="text-right"/>
                        </div>
                        <div class="col-12">
                            <q-input outlined v-model="objMovimiento.descripcion" label="Retiro" dense readonly />
                        </div>
                    </div>
                </q-card-section>
                <q-card-section>
                    <q-table :data="dataAsientos" :columns="columnsAsientos" row-key="id" :filter="filterAsientos">
                        <template v-slot:top-left>
                            <q-input outlined dense label="Fecha Inicial" type="date" v-model="fechaIMov">
                            </q-input>
                            <q-input outlined dense label="FechaFinal" type="date" v-model="fechaFMov">
                            </q-input>
                            <q-btn push color="white" text-color="primary" round icon="search" @click="getAsientos()" >
                                <q-tooltip>Buscar Asientos</q-tooltip>
                            </q-btn>
                        </template>
                        <template v-slot:top-right>
                            <q-input outlined dense debounce="300" v-model="filterAsientos" placeholder="Filtrar" clearable>
                                <template v-slot:append>
                                    <q-icon name="search" />
                                </template>
                            </q-input>
                        </template>
                        <template v-slot:body="props">
                            <q-tr :props="props" :class="props.row.idMovBancarioDet !== null ? 'bg-green-1 text-green-9' : ''">
                                <!-- Columna acciones manual -->
                                <q-td key="acciones" :props="props">
                                <q-btn icon="mdi-arrow-up" round dense flat color="primary" @click="putMovimiento(props.row)">
                                    <q-tooltip>Asignar</q-tooltip>
                                </q-btn>
                                <q-btn 
                                    v-if="props.row.idMovBancarioDet !== null" 
                                    icon="mdi-file-document-check" 
                                    round dense flat color="primary" 
                                    @click="putMovimiento(props.row)"
                                >
                                    <q-tooltip>Ver Movimiento Bancario</q-tooltip>
                                </q-btn>
                                </q-td>

                                <!-- Resto de columnas -->
                                <q-td v-for="col in props.cols.filter(c => c.name !== 'acciones')" :key="col.name" :props="props">
                                {{ col.value }}
                                </q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>
<script>
import { QSpinnerCube } from 'quasar'
import axios from 'axios'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    },
  data() {
    return {
        data: [],
        columns: [
            { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', sortable: true },
            { name: 'conciliado', align: "center", label: '', field:'conciliado', sortable: true },
            { name: 'fecha', align: 'center', label: 'Fecha', field: 'fecha', sortable: true, field: row => row.fecha, format: val => `${this.formatoFecha(val)}`, },
            { name: 'rfc', align: 'left', label: 'RFC', field: 'rfc', sortable: true },
            { name: 'nombre', align: 'left', label: 'Nombre', field: 'nombre', sortable: true },
            { name: 'deposito', align: 'right', label: 'Depósito', field: 'deposito', sortable: true, field: row => row.deposito, format: val => `${this.formatoMiles(val)}`, },
            { name: 'retiro', align: 'right', label: 'Retiro', field: 'retiro', sortable: true, field: row => row.retiro, format: val => `${this.formatoMiles(val)}`, },
            { name: 'descripcion', align: 'left', label: 'Descripción', field: 'descripcion', sortable: true },
        ],
        filter: null,      
        
        //ASIENTOS CONTABLES
        dialogAsientos: false,
        dataAsientos: [],
        columnsAsientos: [
            { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', sortable: true },
            { name: 'fecha', align: 'center', label: 'Fecha', field: 'fecha', sortable: true, field: row => row.fecha, format: val => `${this.formatoFecha(val)}`, },
            { name: 'tipo', align: 'left', label: 'Tipo', field: 'tipo', sortable: true },
            { name: 'numPoliza', align: 'left', label: 'Num. Póliza', field: 'numPoliza', sortable: true },
            { name: 'numCuenta', align: 'left', label: 'Num. Cuenta', field: 'numCuenta', sortable: true },
            { name: 'cargo', align: 'right', label: 'Cargo', field: 'cargo', sortable: true, field: row => row.cargo, format: val => `${this.formatoMiles(val)}`, },
            { name: 'abono', align: 'right', label: 'Abono', field: 'abono', sortable: true, field: row => row.abono, format: val => `${this.formatoMiles(val)}`, },
            { name: 'descripcion', align: 'left', label: 'Descripción', field: 'descripcion', sortable: true },
            // { name: 'idMovBancarioDet', align: 'left', label: 'idMovBancarioDet', field: 'idMovBancarioDet', sortable: true },
        ],
        filterAsientos: null,
        objMovimiento: {
            fecha: null,
            rfc: null,
            nombre: null,
            deposito: 0,
            retiro: 0,
            descripcion: null,
        },
        fechaIMov : null,
        fechaFMov: null,

    }
  },
    computed: {
        token() {
            return this.$store.state.usuario;
        },

        items(){
            return this.$store.state.EstadoCuentaDet;
        },
        montoFormateado() {
            const numero = Number(this.monto);
            if (isNaN(numero)) return "0.00";
            return numero.toLocaleString("es-MX", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            });
        },
    },
   methods: {

    formatoFecha(fecha){
        if(!fecha || fecha === "")
        return ""
        const fechaTexto = fecha.toString();
        return fechaTexto.slice(0, 10)
    },

    formatoMiles(valor){
        const numero = Number(valor);
        if (isNaN(numero)) return "0";
        return numero.toLocaleString("es-MX", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    },

    async verAsientos(item){
        console.log(item)
        const fecha = this.formatoFecha(item.fecha)
        const importe = item.deposito + item.retiro
        this.objMovimiento = {...item}
        this.dataAsientos = []
        this.filterAsientos = this.formatoMiles(importe);
        // https://localhost:7040
        const response = await axios.get(`https://api-blenter.contago.com.mx/api/Polizas/MovBancos/${fecha}/${fecha}`,
        {
            headers: {
                "Content-Type": "application/json",
                "X-RFC": this.token.rfc
            }
        });
        this.dataAsientos = [...response.data]

        this.fechaIMov = fecha;
        this.fechaFMov = fecha;
        this.dialogAsientos = true;
    },

    async getAsientos(){
        this.dataAsientos = []
        // https://localhost:7040

        const response = await axios.get(`https://api-blenter.contago.com.mx/api/Polizas/MovBancos/${this.fechaIMov}/${this.fechaFMov}`,
        {
            headers: {
                "Content-Type": "application/json",
                "X-RFC": this.token.rfc
            }
        });
        this.dataAsientos = [...response.data]
    },

    async putMovimiento(item){
        const objPut = {
            idPoliza:  item.id,
            IdMovBancarioDet: this.objMovimiento.id,
            indice: item.indice
        };
        console.log(objPut);
        const response = await axios.put(`https://api-blenter.contago.com.mx/api/Polizas/PolizaMovBancario/`, objPut,
        {
            headers: {
                "Content-Type": "application/json",
                "X-RFC": this.token.rfc
            }
        });
    },
   }
};
</script>